export default "shealynntate: hey can someone +1 me on the staging deploy?\nmike.r: i got you\nshealynntate: thx\n"